import { LoginState } from "./type";

export const loginInitialState: LoginState = {
  error: null,
  loading: false,
  authenticated: !!localStorage.getItem("token"),
};
